import React, { useCallback, useMemo } from 'react';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { token } from '@atlaskit/tokens';
import type { FlagId } from '@atlassian/jira-flags';
import Flag from '@atlassian/jira-flags/src/common/ui/components/ak-flag';
import { useFlagService } from '@atlassian/jira-flags/src/services';
import { DISMISS_COMMAND, fromFlagId } from '@atlassian/jira-flags/src/services/types';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	id: FlagId;
	isRateLimited?: boolean;
};

export const ResendVerificationEmailErrorFlag = ({ id, isRateLimited = false }: Props) => {
	const { formatMessage } = useIntl();

	const { dismissFlag } = useFlagService();

	const onDismissed = useCallback(() => {
		dismissFlag({
			command: DISMISS_COMMAND,
			id,
		});
	}, [dismissFlag, id]);

	let flagDescription = '';
	let flagTitle = '';

	if (isRateLimited) {
		flagDescription = formatMessage(
			messages.resendVerificationEmailRateLimitFailureFlagDescription,
		);
		flagTitle = formatMessage(messages.resendVerificationEmailRateLimitFailureFlagTitle);
	} else {
		flagDescription = formatMessage(messages.resendVerificationEmailGenericFailureFlagDescription);
		flagTitle = formatMessage(messages.resendVerificationEmailGenericFailureFlagTitle);
	}

	return useMemo(
		() => (
			<Flag
				id={fromFlagId(id)}
				icon={<ErrorIcon spacing="spacious" label="error" color={token('color.icon.danger')} />}
				title={flagTitle}
				description={flagDescription}
				onDismissed={onDismissed}
				messageId="servicedesk-customers-organization-common.common.ui.resend-verification-email-error-flag.flag"
				messageType="transactional"
			/>
		),
		[id, flagTitle, flagDescription, onDismissed],
	);
};
